import { useLocale } from '@edreamsodigeo/frontend-core';

const useDatesStringByLocale = (): {
  getAbbreviatedDay: (day: number) => string;
  getMonth: (month: number) => string;
} => {
  const locale = useLocale();

  const getAbbreviatedDay = (day: number): string => {
    // we create a dummy date so we can extract the string for the locale
    const date = new Date(Date.UTC(2023, 3, day + 2));
    return date.toLocaleDateString(locale, { weekday: 'short' });
  };

  const getMonth = (month: number): string => {
    // we create a dummy date so we can extract the string for the locale
    const date = new Date(Date.UTC(2023, month));
    return date.toLocaleDateString(locale, { month: 'long' });
  };

  return { getAbbreviatedDay, getMonth };
};

export default useDatesStringByLocale;
